export default __webpack_public_path__ + "static/media/auth-bottom.e921a842.svg";